import React from "react";
import isEmpty from "../validations/is-empty";

const SectionTitle = ({ type = "none", title, subtitle, spantitle }) => {
  return (
    <div className="title-section">
      <div className="title-main">
        <hr className="top-hr" />
        <p className="title-text font-amaticsc-bold">
          {title}
          {!isEmpty(spantitle) && (
            <span className="font-zenkurenaido">{spantitle}</span>
          )}
        </p>
        <p className="sub-title-text font-zenkurenaido">{subtitle}</p>
        <hr className="bottom-hr" />
      </div>
      {type === "right" && (
        <>
          <div className="no-section">&nbsp;</div>
          <div className="no-section">&nbsp;</div>
          <div className="no-section">&nbsp;</div>
          <div className="no-section">&nbsp;</div>
        </>
      )}
    </div>
  );
};

export default SectionTitle;
